import { useEffect, useState } from "react";
import { useLazyGetMediaCommentsQuery } from "../../../store/services/mediaApi";

export const useFetchMediaSummaries = (selectedIds = []) => {
  const [summaries, setSummaries] = useState([]);
  const [triggerMediaItemMeta] = useLazyGetMediaCommentsQuery();

  useEffect(() => {
    const fetchSummaries = async () => {
      try {
        const results = await Promise.all(
          selectedIds.map(async (item) => {
            try {
              const res = await triggerMediaItemMeta(
                item.media_item_id
              ).unwrap();

              return {
                media_item_id: item?.media_item_id,
                media_title: item?.subtitle, // assuming you meant to use subtitle as title
                subtitle: item?.subtitle,
                summary_content: res?.summary,
                redirect_uri: `https://portal.volkno.com/${21}/media/${
                  item?.media_item_id
                }/overview`,
              };
            } catch {
              return null;
            }
          })
        );
        setSummaries(results.filter(Boolean));
      } catch (err) {
        console.error("Error fetching media summaries", err);
        setSummaries([]);
      }
    };

    if (selectedIds.length > 0) {
      fetchSummaries();
    }
  }, [selectedIds]);

  return summaries;
};
